import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { HttpService, API, Title, DateFormat } from '../../../config/react'
import DataTable from 'react-data-table-component'
function Reviews() {
  const [ReviewList, setReviewList] = useState([])
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [totalRows, settotalRows] = useState()
  const [currentPage, setCurrentPage] = useState(1)
  const [SearchTerm, setSearchTerm] = useState('')
  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const columns = [
    // {
    //   name: 'Title',
    //   selector: (row) => row.title
    // },
    {
      name: 'Name',
      selector: (row) => row.name
    },
    {
      name: 'Type',
      selector: (row) => row.type
    },
    {
      name: 'Product',
      selector: (row) => row.product_name
    },
    {
      name: 'SKU',
      selector: (row) => row.sku
    },
    {
      name: 'Status',
      selector: (row) =>
        row.status !== '' ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : 'Pending'
    },
    {
      name: 'Created Date',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/marketing/reviews/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]

  useEffect(() => {
    document.title = Title.Reviews
    GetReviewsList()
  }, [CustomFilters, SearchTerm])
  const GetReviewsList = () => {
    const param = {
      page: CustomFilters.page,
      search: SearchTerm,
      page_size: CustomFilters.page_size
    }
    HttpService.postApi(API.GetReviewsList, param).then((response) => {
      if (response.data.status) {
        setReviewList(response.data.result[1])
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total)
      }
    })
  }
  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }
  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Title, Name, Product, SKU, Status."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) =>
          setTimeout(() => {
            setSearchTerm(e.target.value)
          }, 1000)
        }
      />
    )
  })
  return (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.Reviews} </h3>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  // title="Coupons"
                  columns={columns}
                  data={ReviewList}
                  persistTableHead={true}
                  // progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  paginationDefaultPage={currentPage}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Reviews
